import { Component } from '@angular/core';

/**
 * Generated class for the LunchrouletteComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lunchroulette',
  templateUrl: 'lunchroulette.html'
})
export class LunchrouletteComponent {

  text: string;

  constructor() {
    console.log('Hello LunchrouletteComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/lunchroulette/lunchroulette.ts